import type { FilterConfig } from "../types";
import { analysisFilters } from "./filterGroups/analysisFilters";
import { basicFilters } from "./filterGroups/basicFilters";
import { statusFilters } from "./filterGroups/statusFilters";
import { teamFilters } from "./filterGroups/teamFilters";
import { userFilters } from "./filterGroups/userFilters";

/**
 * Filter definitions for DiscoverGames table.
 * Build at runtime (see `getDiscoverGamesColumns`) so `_("...")` runs after i18n init.
 */
export function getDiscoverGamesFilters(): FilterConfig[] {
	return [
		...basicFilters.core(),
		...teamFilters.all(),
		basicFilters.ageCategory(),
		...userFilters.managers(),
		statusFilters.hasVideo(),
		...analysisFilters.providerAndPriority(),
		statusFilters.gameStatus(),
		...statusFilters.visibilityFlags(),
		userFilters.owner(),
		...statusFilters.discoverAndProcessing(),
		analysisFilters.analysisRequestedAt(),
	];
}
